<template>
  <!--存取款组件-->
  <div>
    <!--旧版APP是否开启人脸-->
    <Download
      v-if="isDownLoad"
      :is-down-load="isDownLoad"
      :page-type="pageType"
    />
    <!--黑名单存款弹窗-->
    <BlackListPop
      v-if="isBlackList"
      :is-black-list="isBlackList"
      :source="source"
      :page-type="pageType"
      @changeBlack="changeBlack"
    />
    <!--添加银行卡弹窗-->
    <noBankPop
      v-if="isBankPop"
      :source="source"
      :is-bank-pop="isBankPop"
      :page-type="pageType"
      @changeBank="changeBank"
    />
    <!--人脸识别弹窗-->
    <FacePop
      v-if="isFacePop"
      :source="source"
      :is-face-pop="isFacePop"
      :face-detection="faceDetection"
      :face-channel="faceChannel"
      :page-type="pageType"
      :version="version"
      :source-type="sourceType"
      @changeFacePop="changeFacePop"
    />
    <!--首次存款弹窗-->
    <FirstDeposit
      v-if="isFirstDepositPop"
      :source="source"
      :is-first-deposit-pop="isFirstDepositPop"
      :page-type="pageType"
      @changeFirstDepositPop="changeFirstDepositPop"
    />
    <!--首次提现弹窗-->
    <FirstWithdrawal
      v-if="isFirstWithdrawalPop"
      :source="source"
      :is-first-withdrawal-pop="isFirstWithdrawalPop"
      :page-type="pageType"
      :is-u-s-d-t="isUSDT"
      @changeFirstWithdrawal="changeFirstWithdrawal"
    />
    <!--资料审核提现弹窗-->
    <UnreviewedBank
      v-if="isUnreviewedBank"
      :source="source"
      :is-unreviewed-bank="isUnreviewedBank"
      :err-message="errMessage"
      :page-type="pageType"
      @changeUnreviewedBank="changeUnreviewedBank"
    />
    <NewWithdrawalWithUSDT
      v-if="isShowNewWithdrawalModule"
      :source="source"
      :page-type="pageType"
      @changeNewWithdrawalWithUSDT="changeNewWithdrawalWithUSDT"
      @allowToWithdrawal="allowToWithdrawal"
    />
    <AccUpdatePersonalDataPopup :show="showAccUpdatePersonalDataPopup" @onSkip="onSkipAccUpdatePersonalDataPopup" @onClose="onCloseAccUpdatePersonalDataPopup" />
    <NoWalletPopup :show="showNoWalletPopup" @onClose="onCloseNoWalletPopup" />
  </div>
</template>

<script>
import Download from '@/view/module/Download.vue'
import FacePop from '@/view/module/FacePop.vue'
import BlackListPop from '@/view/module/BlackListPop.vue'
import noBankPop from '@/view/module/noBankPop.vue'
import FirstDeposit from '@/view/module/FirstDeposit.vue'
import FirstWithdrawal from '@/view/module/FirstWithdrawal.vue'
import UnreviewedBank from '@/view/module/UnreviewedBank.vue'
import NewWithdrawalWithUSDT from '@/view/module/NewWithdrawalWithUSDT.vue'
import AccUpdatePersonalDataPopup from '@/view/module/AccUpdatePersonalDataPopup.vue'
import NoWalletPopup from '@/view/module/NoWalletPopup.vue'
import utils from '@/utils/tradeDataUtil'
import { mapState } from 'vuex'
import { errorMap } from '@/utils/helper'
import api from '@/plugins/api'
export default {
  components: {
    Download,
    FacePop,
    BlackListPop,
    noBankPop,
    FirstDeposit,
    FirstWithdrawal,
    UnreviewedBank,
    NewWithdrawalWithUSDT,
    AccUpdatePersonalDataPopup,
    NoWalletPopup
  },
  props: ['source', 'moneyStatus'],
  computed: {
    ...mapState(['pageType', 'version', 'sourceType', 'accountInfo'])
  },
  data() {
    const u = navigator.userAgent
    return {
      isDownLoad: false,
      isBankPop: false,
      isBlackList: false,
      isFacePop: false,
      isFirstDepositPop: false,
      isFirstWithdrawalPop: false,
      isUnreviewedBank: false,
      errMessage: '',
      faceDetection: '',
      faceChannel: '', // 人脸版本
      isAndroid: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1,
      isIOS: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
      isFaceValidate: true, // 是否需要人脸识别
      appObj: '',
      isShowNewWithdrawalModule: false,
      certificateStatus: {
        reason: '',
        status: ''
      },
      isUSDT: false,
      showAccUpdatePersonalDataPopup: false,
      showNoWalletPopup: false
    }
  },
  mounted() {
    if (this.pageType == 'app' || this.sourceType == 'old') {
      this.getAPPInfo()
      // init callback func for ios
      window.getInfoCallback = (...arg) => {
        this.appInfoCallback(...arg)
      }
      this.checkFaceValidate()
    } else {
      if (this.moneyStatus == 'recharge') this.goDeposit()
      if (this.moneyStatus == 'withdrawal') this.goWithdrawal()
    }
  },
  methods: {
    toggleFixed() {
      const mainH = document.getElementById('main')
      mainH.classList.toggle('mainFixed')
    },
    changeBank(data) {
      this.$emit('moneyStatue', data)
      this.isBankPop = data
    },
    changeFacePop(data) {
      this.$emit('moneyStatue', data)
      this.isFacePop = data
    },
    changeBlack(data) {
      this.$emit('moneyStatue', data)
      this.isBlackList = data
    },
    changeFirstDepositPop(data) {
      this.$emit('moneyStatue', data)
      this.isFirstDepositPop = data
    },
    changeFirstWithdrawal(data) {
      this.$emit('moneyStatue', data)
      this.isFirstWithdrawalPop = data
    },
    changeUnreviewedBank(data) {
      this.$emit('moneyStatue', data)
      this.isUnreviewedBank = data
    },
    changeNewWithdrawalWithUSDT(data) {
      this.$emit('moneyStatue', data)
      this.isShowNewWithdrawalModule = data
    },
    getAPPInfo() {
      // 获取app信息
      let mapJson
      try {
        if (this.isIOS) {
          if (typeof window.getInfo != 'undefined') {
            mapJson = window.getInfo()
          } else {
            window.webkit.messageHandlers.getInfo.postMessage(null)
            return
          }
        } else {
          mapJson = window.uiObject.getInfo()
        }
      } catch (err) {
        if (err.message) {
          this.$toast.fail(errorMap.appInfo)
        } else {
          this.$toast.fail(errorMap.appInfo)
        }
        mapJson = ''
      }
      if (mapJson != null && mapJson != '' && mapJson != 'null') {
        this.appObj = eval('(' + mapJson + ')')
        this.getAppChannel(this.appObj)
      } else {
        this.$toast.fail(errorMap.appInfo)
      }
    },
    appInfoCallback(info) {
      if (typeof info != 'undefined') {
        const appInfo = JSON.stringify(info)
        this.appObj = JSON.parse(appInfo)
        this.getAppChannel(this.appObj)
      } else {
        this.$toast.fail(errorMap.appInfo)
      }
    },
    getAppChannel(appObj) {
      let channel, device, version
      if (this.isIOS) {
        channel = appObj.channel ? appObj.channel : ''
        device = 'IOS'
        version = this.version
        // alert("ios版本：" + this.version + ",包名" + appObj.channel);
      } else {
        channel = appObj.flavor ? appObj.flavor : ''
        device = 'Android'
        version = appObj.appVerCode ? appObj.appVerCode : ''
        // alert("版本：" + this.appObj.appVerCode + ",包名" + appObj.flavor);
      }
      const data = {
        channel: channel,
        device: device,
        version: version,
        businessType: '72'
      }
      api.getFaceChannel(this.$qs.stringify(data)).then((res) => {
        if (res.data.code == 200) {
          if (utils.isNotEmpty(res.data.data.faceChannel)) {
            this.isFaceValidate = true
            this.faceChannel = res.data.data.faceChannel
          } else {
            this.isFaceValidate = false
            this.faceChannel = ''
          }
          this.$emit('getFaceVal', this.isFaceValidate)
          if (this.moneyStatus == 'recharge') this.goDeposit()
          if (this.moneyStatus == 'withdrawal') this.goWithdrawal()
        }
      }).catch(() => {
        this.$toast.fail(errorMap.getFaceChannel)
      })
    },
    checkFaceValidate() {
      if (this.sourceType == 'old') {
        this.isFaceValidate = false
        this.goFaceStatus()
      }
    },
    goFaceStatus() {
      this.$bus.$emit('loading', false)
      let equipmentType
      if (this.isIOS) equipmentType = 'IOS'
      else equipmentType = 'Android'
      const data = {
        equipmentType: equipmentType
      }
      api.getFaceStatus(this.$qs.stringify(data)).then((res) => {
        if (res.data.code == 200) {
          this.$bus.$emit('loading', true)
          const data = res.data.data
          if (data.channel) {
            if (data.status) {
              this.isFaceValidate = false
              this.toggleFixed()
              this.isDownLoad = true
            } else {
              this.isFaceValidate = true
              this.faceChannel = 'FACEID'
              if (this.moneyStatus == 'recharge') this.goDeposit()
              if (this.moneyStatus == 'withdrawal') this.goWithdrawal()
            }
          } else {
            this.isFaceValidate = false
            if (this.moneyStatus == 'recharge') this.goDeposit()
            if (this.moneyStatus == 'withdrawal') this.goWithdrawal()
          }
        }
      }).catch(() => {
        this.$toast.fail(errorMap.getFaceStatus)
      })
    },
    goDeposit() {
      this.$bus.$emit('loading', false)
      api.getDepositAuthCertify().then((res) => {
        this.toggleFixed()
        this.$bus.$emit('loading', true)
        if (res.status) {
          if (res.data.code == 200) {
            if (!res.data.data.depositBankStatus) {
              if (res.data.data.noIdCard) {
                this.showAccUpdatePersonalDataPopup = true
                return
              }

              if (res.data.data.walletOnly) {
                this.showNoWalletPopup = true
                return
              }
            }

            if (res.data.data.faceDetection) {
              this.faceDetection = res.data.data.faceDetection
              const depositBankStatus = res.data.data.depositBankStatus
              const certificateStatus = res.data.data.certificateStatus.status
              this.certificateStatus = res.data.data.certificateStatus
              if (
                this.faceDetection.isBlacklist ||
                res.data.data.paySwitchSeqTagCode == 'A9'
              ) {
                this.isBlackList = !this.isBlackList
              } else {
                if (!depositBankStatus) {
                  this.isBankPop = !this.isBankPop
                } else {
                  if (this.faceDetection.isFaceValidate) {
                    if (this.isFaceValidate) {
                      this.isFacePop = !this.isFacePop
                    }
                  } else {
                    if (certificateStatus != 'APPROVAL') {
                      this.isFirstDepositPop = !this.isFirstDepositPop
                    } else {
                      if (this.source == 'home') {
                        this.$router.push({ path: '/home/recharge' })
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }).catch(() => {
        this.toggleFixed()
        this.$bus.$emit('loading', true)
        this.$toast.fail(errorMap.goDeposit)
      })
    },
    async goWithdrawal() {
      this.$bus.$emit('loading', false)
      api.getWithdrawAuthCertify().then((res) => {
        if (res.status) {
          if (res.data.code == 200 && res.data.code_desc == 'success') {
            const certificateStatus = res.data.data.certificateStatus.status
            this.faceDetection = res.data.data.faceDetection
            this.certificateStatus = res.data.data.certificateStatus
            if (this.faceDetection.isBlacklist) {
              this.toggleFixed()
              this.$bus.$emit('loading', true)
              this.isBlackList = !this.isBlackList
            } else {
              if (certificateStatus === 'APPROVAL') {
                this.allowToWithdrawal()
              } else {
                this.handleNewCertify()
              }
            }
          }
        }
      }).catch(() => {
        this.$toast.fail(errorMap.goWithdrawal)
      })
    },
    async handleNewCertify() {
      this.$bus.$emit('loading', false)
      api.getAuthInfo().then(response => {
        const { code, data, code_desc } = response.data
        if (code !== 200) {
          this.$toast.fail(code_desc + errorMap.getAuthInfo)
          return
        }
        const IdCardVerify = data.FILE_TYPE_IDCARD
        const bankCardVerify = data.FILE_TYPE_BANK
        this.$bus.$emit('loading', true)
        const { cashoutTag } = this.accountInfo
        if (cashoutTag === 'X2') { // old, bank and id card verify needed
          if (IdCardVerify.status !== 'APPROVAL') {
            this.testStatus(IdCardVerify.status, IdCardVerify.reason)
            return
          } else if (bankCardVerify.status !== 'APPROVAL') {
            this.isShowNewWithdrawalModule = true
            return
            // if (this.source === 'home' || this.pageType === 'app') {
            //   this.isShowNewWithdrawalModule = true
            //   return
            // }
          }
        } else if (cashoutTag === 'X1') { // new, only need id card, allow usdt withdrawal only
          this.testStatus(IdCardVerify.status, IdCardVerify.reason)
          return
        }
        // fall to original case
        this.testStatus(
          this.certificateStatus.status,
          this.certificateStatus.reason
        )
      }).catch(() => {
        this.$toast.fail(errorMap.getAuthInfo)
      })
    },
    testStatus(status, reason = '') {
      switch (status) {
        case 'APPROVAL': {
          this.allowToWithdrawal()
          break
        }
        case 'PRE_APPROVAL': {
          this.showPreApproval()
          break
        }
        case 'CANCEL': {
          this.showCancel(reason)
          break
        }
        case 'EMPTY':
        default: this.showEmpty()
      }
    },
    allowToWithdrawal() {
      this.isShowNewWithdrawalModule = false
      if (this.faceDetection.isFaceValidate) {
        this.$bus.$emit('loading', true)
        if (this.isFaceValidate) {
          this.toggleFixed()
          this.isFacePop = !this.isFacePop
        }
      } else {
        this.$fireBase.logEvent('click_withdraw', {
          platform_type:
            this.thisPageType == 'app'
              ? 'app端'
              : this.thisPageType == 'trade'
                ? 'H5交易'
                : '用户中心',
          source: '用户中心',
          time: utils.getThisTime(),
          url: window.location.href
        })
        if (this.source == 'home') {
          this.$router.push({ path: '/home/withdrawal' })
        } else if (this.source == 'withdrawal') {
          this.$bus.$emit('loading', true)
        }
      }
    },
    showPreApproval() {
      this.toggleFixed()
      this.$bus.$emit('loading', true)
      this.errMessage = '您的取款资料正在审核中，请耐心等待'
      this.isUnreviewedBank = !this.isUnreviewedBank
    },
    showCancel(msg) {
      this.toggleFixed()
      this.$bus.$emit('loading', true)
      this.errMessage = msg
      this.isUnreviewedBank = !this.isUnreviewedBank
    },
    showEmpty() {
      this.toggleFixed()
      this.$bus.$emit('loading', true)
      this.isFirstWithdrawalPop = !this.isFirstWithdrawalPop
    },
    onSkipAccUpdatePersonalDataPopup() {
      this.showNoWalletPopup = true
      this.showAccUpdatePersonalDataPopup = false
    },
    onCloseAccUpdatePersonalDataPopup() {
      this.showAccUpdatePersonalDataPopup = false
      this.$emit('moneyStatue', false)
    },
    onCloseNoWalletPopup() {
      this.showNoWalletPopup = false
      this.$emit('moneyStatue', false)
    }
  }
}
</script>
